import filter from '../modules/downloadFilter';
import downloadListFilter from '../modules/downloadListFilter';

filter();
downloadListFilter();